import { Table } from "@mui/material";
import { type Ref, forwardRef } from "react";
import type { TableProps } from "react-virtuoso";
import { useTableVirtualizedSelectContext } from "../context";

export const VirtuosoTable = forwardRef(function VirtuosoTable(
  { children, ...props }: TableProps,
  ref: Ref<HTMLTableElement>
) {
  const { TableProps } = useTableVirtualizedSelectContext();

  return (
    <Table {...props} {...TableProps} sx={{ borderCollapse: "separate", ...TableProps?.sx }} ref={ref}>
      {children}
    </Table>
  );
});
